<script lang="ts">
  import { run } from 'svelte/legacy';

  import GameCard from "$lib/components/GameCard.svelte";
  import {page} from "$app/stores";
  import type {IGame} from "$lib/interfaces/IGame";
  import LoadMoreButton from "$lib/elements/LoadMoreButton.svelte";
  import {gameService} from "$lib/services/game.service";
  import {onMount} from "svelte";

  let { data } = $props();

  let providerName = data.providerName;


  let games: IGame[] = $state([]);
  let searchTimeout: ReturnType<typeof setTimeout>;
  let searchQuery;
  run(() => {
    searchQuery = $page.url.searchParams.get('name');
  });
  let currentPage = $state(0);
  let loading = $state(false);
  let searchedGames: IGame[] = $state([]);
  let totalElements = $state(0);

  console.log(totalElements, 'total')


  function handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      searchQuery = input.value;
      updateQueryParameter('name', searchQuery);

      if (!searchQuery?.length) {
        searchedGames = [];
        return;
      }

      loadGames(false);
    }, 300);
  }

  onMount(() => {
    const queryParams = {
      size: 32,
      page: searchQuery?.length ? 0 : currentPage,
      gameProviderSlug: providerName,
    }

    if (searchQuery) {
      Object.assign(queryParams, {
        name: searchQuery,
      });
    }
    gameService.getAllGames(queryParams).then((response) => {
      games = response.data.data;
      totalElements = response.data.totalElements;
    })
  })

  function updateQueryParameter(param: string, value: string) {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(param, value);
    } else {
      url.searchParams.delete(param);
    }
    window.history.replaceState(null, '', url.pathname + url.search);
  }


  function loadMore() {
    loadGames();
  }

  function loadGames(incrementPage = true) {
    if (searchQuery?.length) {
      loading = true
    }

    const queryParams = {
      size: 32,
      page: searchQuery?.length ? 0 : currentPage,
      gameProviderSlug: providerName,
    }

    if (searchQuery) {
      Object.assign(queryParams, {
        name: searchQuery,
      });
    }

    gameService.getAllGames(queryParams)
        .then((response) => {
          if (searchQuery?.length) {
            searchedGames = response.data.data;
          } else {
            games = [...games, ...response.data.data];
            totalElements = response.data.totalElements;
            if (incrementPage) {
              currentPage = response.data.currentPage + 1;
            }
          }
          if (searchQuery?.length) {
            loading = false;
          }
        });
  }

  let pageConfig = {
    title: `Demo - ${providerName} page`,
    description: `Demo - ${providerName} Casino game page`,
    keywords: `${providerName}, ${providerName} game , ${providerName} casino games, ${providerName} online casino games`,
  }
</script>


<svelte:head>
  <title>{pageConfig.title}</title>
  <meta name="description" content="{pageConfig.description}">
  <meta name="keywords" content="{pageConfig.keywords}">
</svelte:head>

<div class="my-8">
  <input
      type="text"
      id="searchBar"
      placeholder="Search"
      required
      class="outline-2 outline-primary-lightBlue border-2 border-primary-lightBlue py-2 px-4 rounded-full w-full bg-transparent text-sm text-white"
      oninput={handleInput}
      value={searchQuery}
  />
</div>

<div class="my-8">
  <h1 class="text-primary-white font-bold text-xl mb-4 gradient-text-fire">{providerName.toUpperCase()}</h1>
  <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-3 md:gap-4">
    {#if loading}
      <div class="min-h-[68vh] flex justify-center items-center col-span-full">
        <img src="/demo-logo.svg" class="animate-bounce" width="140" alt="Demo"/>
      </div>
    {:else if searchQuery?.length}
      {#each searchedGames as game}
        <GameCard {game}/>
      {/each}
    {:else}
      {#each games as game}
        <GameCard {game}/>
      {/each}
    {/if}
  </div>
  {#if !searchQuery?.length}
    <LoadMoreButton currentPage={currentPage + 1} totalElements={totalElements} loadMore={loadMore}/>
  {/if}
</div>
